export const PanelTypes = {
  DETAILS: 'DETAILS',
  PICKER: 'PICKER',
  PICKER_DETAILS: 'PICKER_DETAILS',
  CLIP_EDITOR: 'CLIP_EDITOR'
};
export const DetailsTabs = {
  OPTIMIZATION: 'OPTIMIZATION',
  PERFORMANCE: 'PERFORMANCE',
  CAPTIONS: 'CAPTIONS',
  DETAILS: 'DETAILS',
  VARIANTS: 'VARIANTS'
};